// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_3A_z35XvGhK7zRnLams4hb"};